<template>
  <div class="c-group g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline" size="18"></Icon> 项目</BreadcrumbItem>
    </Breadcrumb>
    <!-- 滚动区域 -->
    <div class="module-content">
      <moduler v-for="item in subModules" :key="item.id" :name="item.href" :title="item.name">
        <!-- 创建类型及账号 -->
        <div v-if="item.href === 'project_create'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">创建类型</span>
            </Col>
            <Col span="12">
              <RadioGroup type="button" v-model="createType">
                <Radio label="CREATE" :disabled="editState">新建项目</Radio>
                <!-- <Radio label="SELECT" :disabled="editState">选择已有项目</Radio> -->
              </RadioGroup>
            </Col>
          </Row>
          <template v-if="createType === 'CREATE'">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">创建方式</span>
              </Col>
              <Col span="12">
                <RadioGroup type="button" v-model="subject">
                  <Radio :label="2">1个项目多个广告</Radio>
                  <Radio :label="1">1个项目下1个广告</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="accountIds.length">
              <Col span="3" class="col-item">
                <span class="item-field">账号选择</span>
              </Col>
              <Col span="16">
                <Spin size="large" fix v-if="show" />
                <select-account v-else v-model="multAccount" :data="accountIds" :media="media" @on-select="selectAll" />
              </Col>
            </Row>
          </template>
        </div>
        <!-- 基础信息 -->
        <div v-if="item.href === 'base_info'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">项目名称</span>
            </Col>
            <Col span="18">
              <input-len
                ref="planinput"
                v-model="formItem.plan_name"
                placeholder="最大90个字符，1个中文等于2个字符"
                width="480"
                :max="90"
                :dyn-pos="dynpos"
                @on-del-trend="validTrend"
                @on-focus="focusPlan"
                @on-blur="blurPlan"
                @change="validTrend"
              />
              <span style="margin-left: 12px" v-if="check">
                <Icon type="ios-loading" color="#5cadff" size="18" v-if="check === 'loading'" />
                <Icon type="md-checkmark" color="#19be6b" size="18" v-if="check === 'success'" />
                <Icon type="md-close" color="#ed4014" size="18" v-if="check === 'error'" />
                <span v-if="check === 'success'">标题可用</span>
                <span v-if="check === 'error'">此标题已被占用，请换一个！</span>
              </span>
              <dd class="dynamic-error g-error-text" v-html="dynErr"></dd>
              <ul class="m-dynamic">
                <span>插入动态名称:</span>
                <li v-for="(word, i) in dynwords" :key="i">
                  <a href="javascript:;" @click.stop="appendTrend(word)">+{{ word }}</a>
                </li>
              </ul>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">应用平台</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.ch_platform_id" type="button" @on-change="platformChange">
                <Radio :label="1">Android</Radio>
                <Radio :label="2">iOS</Radio>
                <Radio :label="3">小程序</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">投放应用</span>
            </Col>
            <Col span="12">
              <el-select
                v-model="formItem.game"
                filterable
                clearable
                @change="handleGame"
                value-key="id"
                placeholder="请选择推广应用"
                style="width: 420px"
              >
                <el-option v-for="item in platformGameData" :key="item.id" :label="item.name" :value="item"> </el-option>
              </el-select>

              <span v-if="formItem.game_id">
                <span v-if="formItem.package" style="margin-top: 12px; display: block; color: #aaa">应用包名：{{ formItem.package }}</span>
                <span v-else style="margin-top: 12px; display: block; color: #ed4014">该应用未配置包名，请找对应运营进行配置</span>
              </span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">自动化任务</span>
            </Col>
            <Col span="12">
              <select-monitor
                :data="formItem.monitorPlan"
                :media="media"
                :open-id="opId"
                @on-delete="delMonitor"
                @on-select="appendMonitor"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">回调开关</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.callback_switch" :true-value="1" :false-value="0" :disabled="formItem.ch_platform_id === 2" />
              <span class="g-error-text" style="margin-left: 12px"
                >注意：IOS一定要开启，安卓接了头条SDK或小程序平台的推广目的为应用APP（微端）时请关闭！</span
              >
            </Col>
          </Row>

          <!-- 安卓应用下载头条分包；预约投放不显示 -->
          <Row class="row-item" :gutter="12" v-if="formItem.ch_platform_id === 1 && formItem.app_promotion_type === 'DOWNLOAD'">
            <Col span="3" class="col-item">
              <span class="item-field">头条分包</span>
            </Col>
            <Col span="12">
              <div class="col-flex" style="height: 32px" v-if="formItem.game_id">
                <!-- <switch-plus v-model="formItem.media_pack_switch" :true-value="1" :false-value="0" :before-change="packValid" :disabled="formItem.media_pack_switch === 1" v-if="formItem.toutiaoAcid || !formItem.game_id"/> -->
                <span v-if="formItem.toutiaoAcid" style="color: #4b7902">分包功能正常</span>
                <span v-else class="g-error-text">该应用未配置头条分包信息，不能使用头条分包功能，请更换应用或者找相关运营进行配置</span>
              </div>
              <div v-if="formItem.toutiaoAcid">
                <p class="m-toutiao-ad">
                  <span>头条应用账号ID：{{ formItem.toutiaoAcid }}</span>
                </p>
                <p class="m-toutiao-ad">
                  <span>头条应用ID：{{ formItem.toutiaoAppid }}</span>
                </p>
              </div>
            </Col>
          </Row>
        </div>
        <div v-if="item.href === 'purpose_scene'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">推广目的</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.landing_type" @on-change="onLandingTypeChange" type="button">
                <Radio label="APP" v-if="formItem.ch_platform_id !== 3">应用推广</Radio>
                <Radio label="MICRO_GAME" v-if="formItem.ch_platform_id === 3">小程序投放</Radio>
                <Radio label="APP" v-if="formItem.ch_platform_id === 3">应用APP（微端）</Radio>
              </RadioGroup>

              <p v-if="formItem.ch_platform_id === 3 && formItem.landing_type === 'APP'" style="color: red; margin-top: 6px">
                提示：开启微端推广目的时，回调开关已关闭
              </p>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.landing_type === 'MICRO_GAME'">
            <Col span="3" class="col-item">
              <span class="item-field">投放内容</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.promotion_content" type="button">
                <Radio label="WECHAT">微信小游戏</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.ch_platform_id !== 3">
            <Col span="3" class="col-item">
              <span class="item-field">子目的</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.app_promotion_type" @on-change="changeAppPromotionType" type="button">
                <Radio label="DOWNLOAD">应用下载</Radio>
                <Radio label="LAUNCH" disabled>应用调起</Radio>
                <Radio label="RESERVE" :disabled="isProcedural">预约下载</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <!-- ios 应用下载时显示子链接 -->
          <Row class="row-item" :gutter="12" v-if="formItem.app_promotion_type === 'DOWNLOAD' && formItem.ch_platform_id === 2">
            <Col span="3" class="col-item">
              <span class="item-field">应用链接</span>
            </Col>
            <Col span="12">
              <el-input v-model="formItem.download_url" placeholder="请输入应用链接"></el-input>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="isReserve">
            <Col span="3" class="col-item">
              <span class="item-field">预约链接</span>
            </Col>
            <Col span="12">
              <el-input v-model="formItem.subscribe_url" placeholder="请输入预约链接"></el-input>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放模式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_mode" @on-change="changeDeliveryMode" type="button">
                <Radio label="MANUAL">手动投放</Radio>
                <Radio label="PROCEDURAL" :disabled="isReserve">自动投放</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">营销场景</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.marketing_goal" type="button">
                <Radio label="VIDEO_AND_IMAGE">短视频+图文</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">广告类型</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.ad_type" type="button">
                <Radio label="ALL">所有广告</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.ch_platform_id === 3">
            <Col span="3" class="col-item">
              <span class="item-field">投放内容</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.micro_promotion_type" type="button">
                <Radio label="WECHAT_GAME">微信小游戏</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </div>

        <div v-if="item.href === 'search_bid' && formItem.delivery_mode === 'MANUAL'">
          <!-- 自动投放/小程序链路/投放范围仅穿山甲时不支持快投
          https://open.oceanengine.com/labels/7/docs/1740868093375503
           -->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">开启</span>
            </Col>
            <Col span="12">
              <i-Switch style="position: relative; top: 3px" v-model="formItem.keywordSwitch" :true-value="1" :false-value="0" />
            </Col>
          </Row>

          <template v-if="formItem.keywordSwitch">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">关键词</span>
              </Col>
              <Col span="12">
                <el-input style="width: 280px" :value="searchBidTips" readonly placeholder="未添加关键词，待自动更新"></el-input>
                <el-button type="text" @click="onSearchKeywordAdd">编辑</el-button>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">出价系数</span>
              </Col>
              <Col span="12">
                <el-input
                  style="width: 280px"
                  v-model="formItem.search_bid_ratio"
                  :disabled="formItem.delivery_setting.bid_type === 'NO_BID'"
                  placeholder="请输入1.00-2.00之间的值，最多2位小数"
                ></el-input>
                <span v-show="formItem.delivery_setting.bid_type === 'NO_BID'">&ensp;最大转化不能设置出价系数</span>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">定向扩展</span>
              </Col>
              <Col span="12" class="ghost-button-styles">
                <el-radio-group v-model="formItem.audience_extend">
                  <el-radio-button ghost label="ON">开启</el-radio-button>
                  <el-radio-button ghost label="OFF">不开启</el-radio-button>
                </el-radio-group>
              </Col>
            </Row>
          </template>
        </div>

        <!-- 版位及定向 -->
        <div v-if="item.href === 'pos_target' && multAccount.length" style="position: relative">
          <select-targeter
            ref="refSctTargeter"
            text="组合"
            v-model="selectorShow"
            :data="targetPlan"
            :media="media"
            :adder="adder"
            :open-id="opId"
            :platform="formItem.ch_platform_id"
            :orign-data="{
              articleData,
              brandData,
              brandDataAll,
              cityData,
              tagsData,
              gategoryData,
              autotendData,
              androidVersion,
              iOSVersion
            }"
            @on-current="setTargeter"
            @on-delete="delTargeter"
            @on-select="appendTargeter"
          />

          <targeting
            ref="targeting"
            :media="media"
            :account="accountId"
            :accounts="multAccount"
            :plan="curTarget"
            :plan-name="curName"
            :landing-type="formItem.landing_type"
            :ch-platform="formItem.ch_platform_id"
            download-type="DOWNLOAD_URL"
            delivery-range="DEFAULT"
            :delivery-mode="formItem.delivery_mode"
            :show="selectorShow"
            :data="{ articleData, brandData, brandDataAll, cityData, tagsData, gategoryData, autotendData, androidVersion, iOSVersion }"
            @on-suggest="getBidSuggest"
            @on-name="targetPlanChange"
            @on-audience-clear="audienceClear"
            @on-audience-all="audienceSelectAll"
            @on-audience-change="audienceRadioChange"
            @on-media-audience-clear="mediaAudienceClear"
            @on-media-audience-all="mediaAudienceSelectAll"
            @on-media-audience-change="mediaAudienceRadioChange"
            @on-radio-change="targetRadioChange"
            @mult-radio-change="targetMultChange"
            @on-change-inventory="selectInventoryAll"
          ></targeting>
        </div>

        <!-- 排期及预算 -->
        <div v-if="item.href === 'schedule_budget'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放时间</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.schedule_type" type="button">
                <Radio label="SCHEDULE_FROM_NOW" :disabled="disableTotal">从今天起长期投放</Radio>
                <Radio label="SCHEDULE_START_END">设置开始和结束日期</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="formItem.delivery_setting.schedule_type === 'SCHEDULE_START_END'" class="row-item" :gutter="12">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <Row v-if="editState">
                <Col span="24">
                  <DatePicker
                    type="date"
                    :value="formItem.delivery_setting.start_time"
                    :options="{ disabledDate: disabledDate }"
                    @on-change="changeStartTime"
                    placeholder="请选择开始日期"
                    style="width: 200px"
                  ></DatePicker>
                  <span class="split-line"> —— </span>
                  <DatePicker
                    type="date"
                    :value="formItem.delivery_setting.end_time"
                    :options="{ disabledDate: disabledEndDate }"
                    @on-change="changeEndTime"
                    placeholder="请选择结束日期"
                    style="width: 200px"
                  ></DatePicker>
                </Col>
              </Row>
              <DatePicker
                type="daterange"
                v-else
                :value="datetime"
                :options="datetimeOption"
                @on-change="changeDatetime"
                placeholder="请选择投放时间"
                style="width: 267px"
              ></DatePicker>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放时段</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.timeRange" type="button" @on-change="radioChange('weektimeData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="RANGE">指定时间段</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="formItem.timeRange === 'RANGE'" class="row-item" :gutter="12">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <drag-weektime v-model="mult_timeRange" :data="weektimeData" @on-clear="clearWeektime"></drag-weektime>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">竞价策略</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.bid_type" type="button" @on-change="changeBidType">
                <Radio label="CUSTOM">稳定成本</Radio>
                <!-- 自动投放禁用控制成本上限 -->
                <Radio label="UPPER_CONTROL" :disabled="isProcedural">控制成本上限</Radio>
                <Radio label="NO_BID">最大转化</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.bid_type === 'CUSTOM'">
            <Col span="3" class="col-item">
              <span class="item-field">广告潜力探索</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.bid_type_upgrade" @on-change="onExploreUpgradeChange" type="button">
                <Radio label="CUSTOM">常规版</Radio>
                <Radio label="EXPLORE_UPGRADE">升级版</Radio>
              </RadioGroup>
              <p style="margin-top: 6px; color: red">注意：广告潜力探索-升级版为【白名单功能】，未开通请勿选择</p>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="enableBidSpeed">
            <Col span="3" class="col-item">
              <span class="item-field">投放速度</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.bid_speed" type="button">
                <Radio label="FAST">加速</Radio>
                <Radio label="BALANCE">匀速</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">项目预算</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.budget_mode" type="button">
                <Radio label="BUDGET_MODE_INFINITE" :disabled="isProcedural">不限</Radio>
                <Radio label="BUDGET_MODE_DAY">设置预算</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="showCBO && !isProcedural">
            <Col span="3" class="col-item">
              <span class="item-field">预算择优分配（CBO）</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.budget_optimize_switch" type="button">
                <Radio label="OFF">不启用</Radio>
                <Radio label="ON">启用</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.budget_mode === 'BUDGET_MODE_DAY'">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">日预算</span>
            </Col>
            <Col span="12">
              <input-number-plus
                :max="7"
                :min="300"
                :step="0.1"
                :maxNum="10000000"
                :precision="2"
                v-model="formItem.delivery_setting.budget"
                placeholder="预算不少于300元，不超过10000000元"
                :width="267"
              />
              <span style="margin-left: 10px">元</span>
            </Col>
          </Row>
          <!-- 自动投放模式，只有稳定成本才显示目标出价 -->
          <Row class="row-item" :gutter="12" v-if="isProcedural && ['CUSTOM'].includes(formItem.delivery_setting.bid_type)">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">目标出价</span>
            </Col>
            <Col span="12">
              <input-number-plus
                :max="5"
                :min="0.1"
                :step="1"
                :maxNum="10000"
                :precision="2"
                v-model="formItem.delivery_setting.cpa_bid"
                placeholder="出价范围：0.1 ~ 10000元"
                :width="267"
              />
              <span style="margin-left: 10px">元</span>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">深度优化方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.delivery_setting.deep_bid_type" type="button">
                <Radio label="">无深度优化</Radio>
                <!-- 预约投放 或 开启广告潜力探索 是禁用，只能选无 -->
                <Radio :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'" label="DEEP_BID_MIN"
                  >自定义双出价</Radio
                >
                <Radio :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'" label="ROI_COEFFICIENT"
                  >ROI系数</Radio
                >
                <Radio :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'" label="BID_PER_ACTION"
                  >每次付费</Radio
                >
                <Radio
                  :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'"
                  label="FIRST_AND_SEVEN_PAY_ROI"
                  >首日ROI+7日ROI</Radio
                >
                <Radio
                  :disabled="isReserve || formItem.delivery_setting.bid_type_upgrade === 'EXPLORE_UPGRADE'"
                  label="PER_AND_SEVEN_PAY_ROI"
                  >每次付费+7日ROI</Radio
                >
              </RadioGroup>
            </Col>
          </Row>

          <!-- 自动投放的项目深度出价设置 -->
          <template v-if="isProcedural && ['CUSTOM'].includes(formItem.delivery_setting.bid_type)">
            <Row
              class="row-item"
              :gutter="12"
              v-if="
                ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(formItem.delivery_setting.deep_bid_type)
              "
            >
              <Col span="3" class="col-item">
                <span class="item-field">ROI系数</span>
              </Col>
              <Col span="12">
                <Input v-model="formItem.delivery_setting.roi_goal" placeholder="ROI系数范围：0.0001 ~ 5" style="width: 320px"> </Input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="formItem.delivery_setting.deep_bid_type === 'DEEP_BID_MIN'">
              <Col span="3" class="col-item">
                <span class="item-field">深度出价</span>
              </Col>
              <Col span="12">
                <input-number-plus
                  :max="4"
                  :min="0.1"
                  :step="1"
                  :maxNum="10000"
                  :precision="2"
                  v-model="formItem.delivery_setting.deep_cpabid"
                  placeholder="出价范围：0.1 ~ 10000元"
                  :width="267"
                />
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">监测链接</span>
            </Col>
            <Col span="12">
              <div class="col-flex" style="height: 32px">
                <span style="color: #aaa">系统自动生成</span>
              </div>
            </Col>
          </Row>
        </div>
      </moduler>
    </div>

    <DeepGoal
      v-model="showGoalModal"
      :accounts="multAccount"
      :platform="formItem.ch_platform_id"
      :game-id="formItem.game_id"
      :package-name="formItem.package"
      :landing-type="formItem.landing_type"
      :app-promotion-type="formItem.app_promotion_type"
      @on-complete="jump"
    ></DeepGoal>

    <SearchBidKeywordSelectModal
      v-model="showSearchBidKeywordModal"
      :account-id="accountId"
      :list="searchBidKeywordList"
      @confirm="onSearchKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>

    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="primary" :loading="loading" @click.stop="submitToNext">
            <span v-if="!loading">下一步</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import { setSession, getSession } from '@/common/js/api'
import {
  isArray,
  isEmpty,
  findCheck,
  getIdOfData,
  deepCopy,
  formatDate,
  getTime,
  dateReplace,
  splicing,
  timeout,
  getKeyOfData,
  betweenTime,
  getByteLen,
  pullKeys,
  clearTagOfData
} from '@/common/js/utils'
import { adAccount, checkGameInfo, checkPlanName, getCaoHuaGames } from '@/api/common.model'

import { bidSuggest, getCustomAudience, actionId2Word, getAwemeCategory, getAwemeAuthorInfo } from '@/api/toutiao.model'

import SelectAccount from './components/group/select-account'
import SelectMonitor from '@/components/select/select-monitor.vue'
import Targeting from './components/targeting/'
import SelectTargeter from '@/components/select/select-target2.vue'
import DragWeektime from '@/components/drag/drag-weektime.vue'
import DeepGoal from './components/deep-goal.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import SearchBidKeywordSelectModal from './components/group/search-bid.vue'

import shortcuts from '@/data/toutiao/shortcuts'
import weektimeData from '@/data/toutiao/weektime_data'
import cityData from '@/data/toutiao/city_province'
import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import brandDataAll from '@/data/toutiao/brand_all_categroy'
import tagsData from '@/data/toutiao/ad_tag'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'
import androidVersion from '@/data/toutiao/android_version'
import iOSVersion from '@/data/toutiao/ios_version'

let Timer
const dynwords = ['日期', '时间', '项目组名', '计划组名', '账号简称']

const disabledDate = (date) => {
  return date && date.valueOf() < Date.now() - 86400000
}

// 处理7*48位值
const getWeektime = (val) => {
  return val
    .map((item) => {
      return item.child.map((ret) => (ret.check ? '1' : '0')).join('')
    })
    .join('')
}

const localAudience = (accounts) => {
  const local = JSON.parse(JSON.stringify(accounts))
  return local.map((ret) => {
    ret.includes = []
    ret.excludes = []
    return ret
  })
}
const localMediaAudience = (accounts) => {
  const local = JSON.parse(JSON.stringify(accounts))
  return local.map((ret) => {
    ret.mediaIncludes = []
    ret.mediaExcludes = []
    return ret
  })
}

const defaultTargetParams = {
  inventory_catalog: 'MANUAL', // 投放位置
  inventory_type: [
    'INVENTORY_FEED',
    'INVENTORY_VIDEO_FEED',
    'INVENTORY_AWEME_FEED',
    'INVENTORY_TOMATO_NOVEL',
    'INVENTORY_UNION_SLOT',
    'UNION_BOUTIQUE_GAME'
  ],
  union_video_type: 'REWARDED_VIDEO', // 投放形式
  district: 'NONE', // 地域类型
  location_type: 'HOME', // 受众位置类型
  gender: 'NONE', // 受众性别
  age: 'NONE', // 受众年龄区间
  tags: 'NONE', // 兴趣分类
  tag_words: 'NONE', // 兴趣关键词
  interest_action_mode: 'UNLIMITED', // 行为兴趣定向
  action_scene: [], // 行为场景
  action_days: 30, // 行为天数
  action_tags: [], // 行为定向
  word_tags: [], // 兴趣定向
  ac: 'NONE', // 受众网络类型
  carrier: 'NONE', // 受众运营商
  activate_type: 'NONE', // 用户首次激活时间
  brand: 'NONE', // 受众手机品牌
  price: 'NONE', // 手机价格
  article: 'NONE', // 受众文章分类
  retargeting_type: 'NONE', // 定向与排除
  app_behavior_target: 'NONE', // APP行为定向
  platform: ['ANDROID'], // 受众平台
  android_osv: '0.0', // Android版本
  ios_osv: '0.0',
  hide_if_converted: 'NO_EXCLUDE',
  launch_price: '', // 手机价格
  superior_popularity_type: 'NONE', // 流量位置
  device: 'NONE',
  device_type: [], // 设备类型
  retargeting_tags_include: [],
  retargeting_tags_exclude: [],
  flow_package: [],
  exclude_flow_package: [],
  auto_extend_enabled: 'OFF', // 智能放量
  fan_tags: [],
  aweme_talents: 'NONE',
  aweme_fan_behaviors: [],
  aweme_fan_time_scope: 'FIFTEEN_DAYS',
  filter_aweme_abnormal_active: 0, // 过滤高活跃用户
  filter_own_aweme_fans: 0, // 过滤自己的粉丝
  filter_aweme_fans_count: 0 // 过滤高关注数用户
}

export default {
  name: 'lGroup',
  mixins: [mixin],
  components: {
    SelectAccount,
    SelectMonitor,
    DragWeektime,
    Targeting,
    SelectTargeter,
    DeepGoal,
    InputNumberPlus,
    SearchBidKeywordSelectModal
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    platformGameData() {
      return this.dataGames.filter((ret) => ret.ch_platform_id === this.formItem.ch_platform_id)
    },
    multAccount() {
      return findCheck(this.accountIds)
    },
    disabledEndDate() {
      if (this.formItem.delivery_setting.start_time) {
        return (date) => {
          return date && date.valueOf() < getTime(this.formItem.delivery_setting.start_time)
        }
      } else return this.disabledDate
    },
    mult_timeRange() {
      const arr = []
      this.weektimeData.forEach((item) => {
        arr.push({
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        })
      })
      return arr
    },
    curTarget() {
      const { targetingParam } = this.targetPlan.filter((ret) => ret.check).pop() || []
      return targetingParam || {}
    },
    curName() {
      const { targetingName } = this.targetPlan.filter((ret) => ret.check).pop() || []
      return targetingName || ''
    },
    adder() {
      return this.targetPlan.length < 50
    },
    accountId() {
      return this.multAccount[0]?.id || 3232
    },
    isProcedural() {
      return this.formItem.delivery_mode === 'PROCEDURAL'
    },
    enableBidSpeed() {
      // 自动投放不支持
      if (this.isProcedural) return false
      return this.formItem.delivery_setting.bid_type === 'CUSTOM'
    },
    showCBO() {
      const { budget_mode, bid_type } = this.formItem.delivery_setting
      return budget_mode === 'BUDGET_MODE_DAY' && bid_type === 'NO_BID'
    },
    searchBidTips() {
      const keywords = this.formItem.keywords
      const len = keywords.length
      if (len) {
        const [firstItem] = keywords
        return `已选${firstItem.word}...共${len}个关键词`
      }
      return '未添加关键词，待自动更新'
    },
    // 是否预约下载子目的
    isReserve() {
      return this.formItem.app_promotion_type === 'RESERVE'
    }
  },
  methods: {
    onExploreUpgradeChange(v) {
      if (v === 'EXPLORE_UPGRADE') {
        this.formItem.delivery_setting.deep_bid_type = ''
      }
    },
    changeAppPromotionType() {
      if (this.isReserve) {
        // 如果是预约投放，深度优化切换到[无]
        this.formItem.delivery_setting.deep_bid_type = ''
      }
    },
    onSearchKeywordAdd() {
      this.showSearchBidKeywordModal = true
    },
    onSearchKeywordSelectConfirm(list) {
      // 用于再次打开回显
      this.searchBidKeywordList = list
      // 用于项目提交
      this.formItem.keywords = list.map((item) => ({ word: item.keyword, bid_type: 'FEED_TO_SEARCH', match_type: item.patern.value }))
    },
    changeDeliveryMode(v) {
      this.formItem.delivery_setting.budget_mode = 'BUDGET_MODE_DAY'

      // 子目的只支持手动投放
      if (v === 'PROCEDURAL') {
        this.formItem.app_promotion_type = 'DOWNLOAD'
      }

      // 当delivery_mode = PROCEDURAL &&landing_type = APP/MICRO_GAME时不支持UPPER_CONTROL；
      // 切换到CUSTOM 稳定成本
      const { bid_type } = this.formItem.delivery_setting
      if (bid_type === 'UPPER_CONTROL') {
        this.formItem.delivery_setting.bid_type = 'CUSTOM'
      }
    },
    getExtraArrEl(arr1, arr2) {
      const lArr = arr1.length > arr2.length ? arr1 : arr2
      const sArr = arr1.length > arr2.length ? arr2 : arr1
      const idx = lArr.findIndex((ret) => !sArr.includes(ret))
      return lArr[idx]
    },
    focusPlan() {
      Timer && clearTimeout(Timer)
    },
    blurPlan() {
      Timer = setTimeout(() => {
        this.checkPlan()
      }, 1000)
    },
    checkPlan() {
      const name = deepCopy(this.formItem.plan_name)
      if (isEmpty(name)) return
      this.check = 'loading'
      checkPlanName({ planName: name })
        .then((data) => {
          this.check = data ? 'success' : 'error'
        })
        .catch(() => {
          this.check = 'error'
        })
    },
    // 添加动态词
    appendTrend(word) {
      const title = deepCopy(this.formItem.plan_name)
      const { selectionStart } = this.$refs.planinput[0].$refs.input.$refs.input
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.formItem.plan_name = `${prefix}{${word}}${suffix}`
      this.validTrend()
      this.$refs.planinput[0].focus()
    },
    // 动态词验证
    validTrend() {
      const name = deepCopy(this.formItem.plan_name)
      if (isEmpty(name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(name, '{') !== count(name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (name.replace(regexp, '').includes('{') || name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = name.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.dynpos = dynPos
      this.dynErr = dynErr
    },
    onLandingTypeChange(landingType) {
      // v4.26.1 如果是小程序投放，且推广目的为应用app（微端）时，定向切换到安卓
      if (this.formItem.ch_platform_id === 3) {
        if (landingType === 'APP') {
          this.formItem.app_type = 'APP_ANDROID'
          this.$set(this.curTarget, 'platform', ['ANDROID'])

          // 开启微端推广目的时，关闭回调开关
          this.formItem.callback_switch = 0
        }

        if (landingType === 'MICRO_GAME') {
          this.formItem.app_type = 'NONE'
          this.$set(this.curTarget, 'platform', 'NONE')
          // 开启微信小程序推广目的时，开启回调开关
          this.formItem.callback_switch = 1
        }
      }
    },

    togglePlatform(platform) {
      if (platform === 1) {
        this.formItem.app_type = 'APP_ANDROID'
        this.$set(this.curTarget, 'platform', ['ANDROID'])
      } else if (platform === 2) {
        this.formItem.app_type = 'APP_IOS'
        this.$set(this.curTarget, 'platform', ['IOS'])
      } else if (platform === 3) {
        this.formItem.app_type = 'NONE'
        this.$set(this.curTarget, 'platform', 'NONE')
      }
    },

    platformChange(val) {
      this.formItem.game_id = ''
      this.$set(this.formItem, 'game_id', '')
      this.$set(this.formItem, 'landing_type', val === 3 ? 'MICRO_GAME' : 'APP')
      // this.$set(this.formItem, 'domain_obscur', 0)
      // this.$set(this.formItem, 'replace_url', '')
      this.$set(this.curTarget, 'android_osv', '0.0')
      this.$set(this.curTarget, 'app_behavior_target', 'NONE')
      this.$set(this.curTarget, 'app_behavior_target', 'NONE')
      this.$set(this.curTarget, 'hide_if_converted', 'NO_EXCLUDE')
      clearTagOfData(this.brandData, this)
      clearTagOfData(this.brandDataAll, this)
      clearTagOfData(this.gategoryData, this)

      this.togglePlatform(val)
    },
    // 选择游戏
    handleGame(meta) {
      this.formItem.game_id = meta.id
      this.formItem.package = meta.ad_package // 更改成显示包名
      this.formItem.game_address = meta.game_address // 包下载地址|落地页
      this.formItem.download_url = meta.game_address
      this.formItem.subscribe_url = meta.game_address
      this.formItem.toutiaoAcid = meta.toutiaoAcid
      this.formItem.toutiaoAppid = meta.toutiaoAppid
      this.formItem.callback_switch = this.formItem.ch_platform_id === 1 && isArray(meta.sdks) && meta.sdks.includes('2002') ? 0 : 1
    },
    // 删除自动化规则
    delMonitor(id) {
      const index = this.formItem.monitorPlan.findIndex((ret) => ret.id === id)
      if (index > -1) this.formItem.monitorPlan.splice(index, 1)
    },
    // 添加自动化规则回调
    appendMonitor(val) {
      this.$set(this.formItem, 'monitorPlan', val)
    },
    changeDatetime(val) {
      const start = dateReplace(val[0])
      const end = dateReplace(val[1])
      this.formItem.delivery_setting.start_time = formatDate(start, 'yyyy-MM-dd')
      this.formItem.delivery_setting.end_time = formatDate(end, 'yyyy-MM-dd')
    },
    changeStartTime(val) {
      this.formItem.delivery_setting.start_time = formatDate(new Date(val), 'yyyy-MM-dd')
      if (getTime(this.formItem.delivery_setting.end_time) < getTime(this.formItem.delivery_setting.start_time)) this.changeEndTime(val)
    },
    changeEndTime(val) {
      this.formItem.delivery_setting.end_time = formatDate(new Date(val), 'yyyy-MM-dd')
    },
    // 清空时间段
    clearWeektime() {
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    changeBidType(meta) {
      // 开启最大转化，清空搜索快投的出价系数
      if (meta === 'NO_BID') this.formItem.search_bid_ratio = ''

      if (this.formItem.delivery_mode === 'PROCEDURAL' && meta === 'NO_BID') this.formItem.delivery_setting.budget_optimize_switch = 'ON'
      else this.formItem.delivery_setting.budget_optimize_switch = 'OFF'
    },
    resetValid() {
      this.formErr = false
      this.errRes = []
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          if (!ret.disabled) this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      if (isArray(data)) setAllChecked(data, check)
    },

    // 定向相关方法

    // 切换定向
    setTargeter(index) {
      const item = this.targetPlan[index]
      // 清空原选中
      this.targetPlan.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      if (item.targetingId) {
        this.saveTargetingId = item.targetingId
        this.saveTitle = item.targetingName
        this.saveDesc = item.targetingDesc
      } else {
        this.saveTargetingId = undefined
        this.saveTitle = ''
        this.saveDesc = ''
      }

      this.selectorShow = false
      this.$set(item, 'check', true)
      // 多选值得清空与解析
      this.decompile(item.targetingParam.city, 'cityData')
      this.decompile(item.targetingParam.ad_tag, 'tagsData')
      this.decompile(item.targetingParam.app_category, 'gategoryData')
      this.decompileKey(item.targetingParam.article_category, 'articleData')
      this.decompileKey(item.targetingParam.device_brand, 'brandData')
      this.decompileKey(item.targetingParam.device_brand, 'brandDataAll')
      this.decompileKey(item.targetingParam.auto_extend_targets, 'autotendData')
      delete item.targetingParam.city1

      timeout(50).then(() => {
        this.selectorShow = true
        if (this.$refs.targeting && this.$refs.targeting[0]) {
          this.$refs.targeting[0].resetAudience()
          this.$refs.targeting[0].resetMediaAudience()
          timeout(300).then(() => {
            this.autoSelectAudience(item)
            this.autoSelectMediaAudience(item)
          })
        }
      })
    },
    // 账号有选中的定位
    autoSelectAudience(item) {
      const isTargeting = item.targetingParam.retargeting_tags.some((ret) => ret.excludes.length || ret.includes.length)
      if (this.$refs.targeting && this.$refs.targeting[0] && isTargeting) {
        let current
        if (item.targetingParam.retargeting_type === 'NONE') {
          this.$set(item.targetingParam, 'retargeting_type', 'RETARGETING_INCLUDE')
          item.check && this.decompileKey(item.targetingParamJson.auto_extend_targets, 'autotendData')
        }
        item.targetingParam.retargeting_tags.some((ret) => {
          if (ret.excludes.length || ret.includes.length) {
            current = ret.id
            return true
          }
        })
        if (current) this.$refs.targeting[0].currentRetarget(current)

        // if (item.targetingParam.retargeting_type === 'RETARGETING_INCLUDE') {
        //   this.$refs.targeting[0].currentRetarget(this.multAccount[0].id)
        // }
        // if (item.targetingParam.superior_popularity_type === 'CUSTOM') {
        //   this.$refs.targeting[0].currentMediaRetarget(this.multAccount[0].id)
        // }
      }
    },
    autoSelectMediaAudience(item) {
      const isTargeting = item.targetingParam.media_retargeting_tags.some((ret) => ret.mediaExcludes.length || ret.mediaIncludes.length)
      if (this.$refs.targeting && this.$refs.targeting[0] && isTargeting) {
        let current
        if (item.targetingParam.superior_popularity_type === 'NONE') {
          this.$set(item.targetingParam, 'superior_popularity_type', 'CUSTOM')
          item.check && this.decompileKey(item.targetingParamJson.auto_extend_targets, 'autotendData')
        }
        item.targetingParam.media_retargeting_tags.some((ret) => {
          if (ret.mediaExcludes.length || ret.mediaIncludes.length) {
            current = ret.id
            return true
          }
        })
        if (current) this.$refs.targeting[0].currentMediaRetarget(current)
      }
    },
    // 删除定向
    delTargeter(index) {
      const idx = this.targetPlan.findIndex((ret) => ret.check)
      const len = this.targetPlan.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个定向'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setTargeter(index - 1)
        else this.setTargeter(1)
      }
      this.targetPlan.splice(index, 1)
    },
    // 添加定向
    appendTargeter(target) {
      const len = this.targetPlan.length
      if (isArray(target)) {
        if (target.length > 50 - len) {
          const idx = target.length - (50 - len)
          target.splice(-idx, idx)
        }
        // 选择定向
        target.map((ret) => {
          const accountIds = ret.accountIds
          const accountParam = {
            retargeting_tags: JSON.parse(JSON.stringify(localAudience(this.multAccount))),
            media_retargeting_tags: JSON.parse(JSON.stringify(localMediaAudience(this.multAccount)))
          }
          const {
            retargeting_tags_include,
            retargeting_tags_exclude,
            media_includes,
            media_excludes,
            ac,
            age,
            carrier,
            activate_type,
            article_category,
            device_brand,
            device_type,
            android_osv,
            ios_osv,
            launch_price,
            interest_action_mode,
            fan_tags,
            aweme_fan_categories,
            aweme_fan_accounts
          } = ret.targetingParamJson
          const targetingParamJson = Object.assign({}, defaultTargetParams, ret.targetingParamJson)
          this.$set(ret, 'targetingParam', Object.assign({}, targetingParamJson, accountParam))
          this.$set(ret.targetingParam, 'retargeting_type', 'NONE') // 定向默认空
          // if (superior_popularity_type === 'GAME' && this.formItem.delivery_range !== 'UNION') this.$set(ret.targetingParam, 'superior_popularity_type', 'NONE')
          // this.$set(ret.targetingParam, 'superior_popularity_type', 'NONE')
          // 系统定向导入
          if (isArray(ac) && !ac.length) this.$set(ret.targetingParam, 'ac', 'NONE')
          if (isArray(age) && !age.length) this.$set(ret.targetingParam, 'age', 'NONE')
          if (isArray(carrier) && !carrier.length) this.$set(ret.targetingParam, 'carrier', 'NONE')
          if (isArray(activate_type) && !activate_type.length) this.$set(ret.targetingParam, 'activate_type', 'NONE')
          if (isArray(article_category) && article_category.length) this.$set(ret.targetingParam, 'article', 'ARTICLE')
          if (isArray(device_brand) && device_brand.length) this.$set(ret.targetingParam, 'brand', 'BRAND')
          if (isArray(device_type) && !device_type.length) this.$set(ret.targetingParam, 'device', 'NONE')
          else if (isArray(device_type)) this.$set(ret.targetingParam, 'device', 'DEVICE')
          else {
            this.$set(ret.targetingParam, 'device', 'NONE')
            this.$set(ret.targetingParam, 'device_type', [])
          }
          if (android_osv === 'NONE') this.$set(ret.targetingParam, 'android_osv', '0.0')
          if (ios_osv === 'NONE') this.$set(ret.targetingParam, 'ios_osv', '0.0')
          if (isArray(launch_price) && !launch_price.length) {
            this.$set(ret.targetingParam, 'price', 'NONE')
            this.$set(ret.targetingParam, 'launch_price', [0, 11000])
          } else if (isArray(launch_price) && launch_price[0] === 0 && launch_price[1] === 11000) {
            this.$set(ret.targetingParam, 'price', 'NONE')
          } else if (isArray(launch_price)) this.$set(ret.targetingParam, 'price', 'CUSTOM')
          else this.$set(ret.targetingParam, 'price', 'NONE')
          // 行为兴趣定向
          if (interest_action_mode === 'CUSTOM') {
            const { action_categories, action_days, action_scene, action_words, interest_categories, interest_words } =
              ret.targetingParamJson
            if (isArray(action_scene) && !action_scene.length) action_scene.push(...['E-COMMERCE', 'NEWS', 'APP'])
            if (isArray(action_categories) && isArray(action_words)) {
              ;(async () => {
                const actionIdWord = await this.id2word(action_categories, action_words, action_days, action_scene)
                this.$set(ret.targetingParam, 'action_tags', actionIdWord)
              })()
            }
            if (isArray(interest_categories) && isArray(interest_words)) {
              ;(async () => {
                const tagsIdWord = await this.id2word(interest_categories, interest_words)
                this.$set(ret.targetingParam, 'word_tags', tagsIdWord)
              })()
            }
          }
          // 抖音达人定向
          const BoolAwemeTalents =
            (isArray(aweme_fan_categories) && aweme_fan_categories.length) || (isArray(aweme_fan_accounts) && aweme_fan_accounts.length)
          if (isArray(fan_tags) && fan_tags.length) this.$set(ret.targetingParam, 'aweme_talents', 'CUSTOM')
          else if (BoolAwemeTalents) {
            const { aweme_fan_behaviors } = ret.targetingParamJson
            this.$set(ret.targetingParam, 'aweme_talents', 'CUSTOM')
            if (isArray(aweme_fan_categories) || isArray(aweme_fan_accounts)) {
              ;(async () => {
                const fansIdWord = await this.fansacount2word(aweme_fan_categories, aweme_fan_accounts, aweme_fan_behaviors)
                this.$set(ret.targetingParam, 'fan_tags', fansIdWord)
              })()
            }
          }
          if (isArray(retargeting_tags_include) && retargeting_tags_include.length) {
            ret.targetingParam.retargeting_tags.forEach((met) => {
              ;(async () => {
                const data = await getCustomAudience({ account: met.id })
                if (data && data.success && isArray(data.models.retData)) {
                  const retIncludes = data.models.retData
                    .map((r) => {
                      return {
                        id: r.custom_audience_id,
                        name: r.name,
                        source: r.source
                      }
                    })
                    .filter((f) => retargeting_tags_include.includes(f.id))
                  this.$set(met, 'includes', retIncludes)
                  this.$nextTick(() => {
                    this.autoSelectAudience(ret)
                    ret.targetingParam.retargeting_tags_include && delete ret.targetingParam.retargeting_tags_include
                  })
                }
              })()
            })
          }
          if (isArray(retargeting_tags_exclude)) {
            ret.targetingParam.retargeting_tags.forEach((met) => {
              ;(async () => {
                const data = await getCustomAudience({ account: met.id })
                if (data && data.success && isArray(data.models.retData)) {
                  const retExcludes = data.models.retData
                    .map((r) => {
                      return {
                        id: r.custom_audience_id,
                        name: r.name,
                        source: r.source
                      }
                    })
                    .filter((f) => retargeting_tags_exclude.includes(f.id))
                  this.$set(met, 'excludes', retExcludes)
                  this.$nextTick(() => {
                    this.autoSelectAudience(ret)
                    ret.targetingParam.retargeting_tags_exclude && delete ret.targetingParam.retargeting_tags_exclude
                  })
                }
              })()
            })
          }
          const flow_package = media_includes ? media_includes.map((ret) => ret.id) : ''
          const exclude_flow_package = media_excludes ? media_excludes.map((ret) => ret.id) : ''
          if (isArray(flow_package) && flow_package.length) {
            ret.targetingParam.media_retargeting_tags.forEach((met) => {
              this.$set(met, 'mediaIncludes', Number(accountIds) === met.id ? media_includes : [])
              this.$nextTick(() => {
                this.autoSelectMediaAudience(ret)
                ret.targetingParam.media_includes && delete ret.targetingParam.media_includes
              })
            })
          }
          if (isArray(exclude_flow_package)) {
            ret.targetingParam.media_retargeting_tags.forEach((met) => {
              this.$set(met, 'mediaExcludes', Number(accountIds) === met.id ? media_excludes : [])
              this.$nextTick(() => {
                this.autoSelectMediaAudience(ret)
                ret.targetingParam.exclude_flow_package && delete ret.targetingParam.exclude_flow_package
              })
            })
          }
          return ret
        })
        this.targetPlan.push(...target)
      } else {
        const defaultParam = JSON.parse(JSON.stringify(defaultTargetParams))
        const accountParam = {
          retargeting_tags: JSON.parse(JSON.stringify(localAudience(this.multAccount))),
          media_retargeting_tags: JSON.parse(JSON.stringify(localMediaAudience(this.multAccount)))
        }
        let targetingParam = JSON.parse(JSON.stringify(this.curTarget))
        if (!targetingParam.retargeting_tags || !targetingParam.media_retargeting_tags) {
          targetingParam = Object.assign(defaultParam, accountParam)
        }
        this.targetPlan.push({
          targetingId: '',
          targetingName: `定向包${len + 1}`,
          targetingParam: JSON.parse(JSON.stringify(targetingParam))
        })
      }
      timeout(50).then(() => {
        this.selectorShow = true
        if (this.$refs.refSctTargeter && this.$refs.refSctTargeter[0]) {
          const { $refs } = this.$refs.refSctTargeter[0]
          $refs && $refs.barContent && ($refs.barContent.scrollLeft = 2800)
        }
        this.setTargeter(this.targetPlan.length - 1)
      })
    },
    decompile(Ids, data) {
      this.targetRadioChange(data)
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          !ret.disabled && this.$set(ret, 'check', true)
        })
      }
      if (isArray(Ids) && Ids.length) {
        Ids.forEach((ret) => {
          const item = getKeyOfData(this[data], 'id', ret)
          deepSelect([item])
        })
      }
    },
    decompileKey(vals, data) {
      this.targetRadioChange(data)
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          !ret.disabled && this.$set(ret, 'check', true)
        })
      }
      if (isArray(vals) && vals.length) {
        vals.forEach((ret) => {
          const item = getKeyOfData(this[data], 'key', ret)
          deepSelect([item])
        })
      }
    },
    async id2word(cate_ids, word_ids, day, scene) {
      const params = {}
      const getWords = []
      // 行为
      if (day) {
        Object.assign(params, {
          ad_account_id: this.accountId,
          targeting_type: 'ACTION',
          action_scene: scene.join(','),
          action_days: day
        })
        cate_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: cate_ids.join(','), tag_type: 'CATEGORY' })))
        word_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: word_ids.join(','), tag_type: 'KEYWORD' })))
      } else {
        Object.assign(params, {
          ad_account_id: this.accountId,
          targeting_type: 'INTEREST'
        })
        cate_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: cate_ids.join(','), tag_type: 'CATEGORY' })))
        word_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: word_ids.join(','), tag_type: 'KEYWORD' })))
      }
      const data = await Promise.all(getWords)
      const [cates, words] = data
      let cate_tags = []
      let word_tags = []
      if (cates && isArray(cates.categories)) {
        cate_tags = cates.categories.map((ret) => {
          ret.type = 'CATEGORY'
          return ret
        })
      }
      if (!cate_ids.length && word_ids.length && cates && isArray(cates.keywords)) {
        word_tags = cates.keywords.map((ret) => {
          ret.type = 'KEYWORD'
          return ret
        })
      } else if (words && isArray(words.keywords)) {
        word_tags = words.keywords.map((ret) => {
          ret.type = 'KEYWORD'
          return ret
        })
      }
      if (day) return [...cate_tags, ...word_tags]
      else return [...cate_tags, ...word_tags]
    },
    async fansacount2word(aweme_fan_categories, aweme_fan_accounts, aweme_fan_behaviors) {
      const promise = []
      const params = { ad_account_id: this.accountId, behaviors: aweme_fan_behaviors }
      const hasCate = isArray(aweme_fan_categories) && aweme_fan_categories.length
      const hasAcct = isArray(aweme_fan_accounts) && aweme_fan_accounts.length
      if (hasCate) promise.push(getAwemeCategory(params))
      if (hasAcct) promise.push(getAwemeAuthorInfo(Object.assign({}, params, { labelIds: aweme_fan_accounts })))
      const res = await Promise.all(promise)
      const mapComplete = (cates, parents) => {
        isArray(cates) &&
          cates.forEach((ret) => {
            parents.push(ret)
            if (isArray(ret.children) && ret.children.length) parents.concat(mapComplete(ret.children, parents))
          })
        return parents
      }
      if (hasCate && hasAcct) {
        const [categories, fanaccounts] = res
        const cate_tags = mapComplete(categories, [])
          .filter((ret) => aweme_fan_categories.includes(ret.id))
          .map((ret) => {
            return {
              id: ret.id,
              key: ret.id,
              value: ret.value,
              name: ret.value,
              num: ret.fans_num_str,
              type: 'CATEGORY'
            }
          })
        const word_tags = fanaccounts.map((ret) => {
          return {
            id: ret.label_id,
            name: ret.author_name,
            key: ret.label_id,
            num: ret.total_fans_num_str,
            value: ret.author_name,
            type: 'KEYWORD',
            aweme: ret.aweme_id,
            avatar: ret.avatar
          }
        })
        return [...cate_tags, ...word_tags]
      } else if (hasCate) {
        const [categories] = res
        return mapComplete(categories, [])
          .filter((ret) => aweme_fan_categories.includes(ret.id))
          .map((ret) => {
            return {
              id: ret.id,
              key: ret.id,
              value: ret.value,
              name: ret.value,
              num: ret.fans_num_str,
              type: 'CATEGORY'
            }
          })
      } else if (hasAcct) {
        const [fanaccounts] = res
        return fanaccounts.map((ret) => {
          return {
            id: ret.label_id,
            name: ret.author_name,
            key: ret.label_id,
            num: ret.total_fans_num_str,
            value: ret.author_name,
            type: 'KEYWORD',
            aweme: ret.aweme_id,
            avatar: ret.avatar
          }
        })
      } else return []
    },
    // 建议出价
    getBidSuggest() {
      // const params = Object.assign({}, this.adjustment(), { ad_account_id: this.account })
      // delete params.retargeting_tags
      // delete params.action_tags
      // delete params.word_tags
      // this.pricing = true
      // bidSuggest(params).then(data => {
      //   this.pricing = false
      //   if (data) {
      //     data.suggested_bid && (this.suggestStat = data.suggested_bid)
      //     data.smart_budget_range && (this.suggestRange = data.smart_budget_range)
      //   }
      // })
    },
    async suggestBudget() {
      const params = Object.assign({}, this.adjustment(), { ad_account_id: this.accountId })
      delete params.retargeting_tags
      delete params.action_tags
      delete params.word_tags
      const data = await bidSuggest(params)
      return data
    },
    adjustment() {
      const targetPlans = JSON.parse(JSON.stringify(this.targetPlan.filter((ret) => ret.check)))
      const targetPlan = targetPlans.length && targetPlans.pop()
      let params = JSON.parse(JSON.stringify(this.formItem))

      // 合并当前定向
      if (targetPlan) {
        const { targetingParam } = targetPlan
        params = targetingParam && Object.assign({}, params, targetingParam)
      }

      // 不限处理
      if (params.gender === 'NONE') delete params.gender
      if (params.age === 'NONE') delete params.age
      if (params.carrier === 'NONE') delete params.carrier
      if (params.ac === 'NONE') delete params.ac
      if (params.platform === 'NONE') delete params.platform
      if (params.tags === 'REFEREE') params.ad_tag = [0] // 系统推荐
      // if (params.adjust_cpa === 0 && params.smart_bid_type === 'SMART_BID_CONSERVATIVE') params.cpa_bid = 0 // 自动出价

      // 精选流量包
      // if (!['APP', 'GAME'].includes(params.superior_popularity_type)) {
      //   if (params.superior_popularity_type === 'INCLUDE') delete params.exclude_flow_package
      //   else if (params.superior_popularity_type === 'EXCLUDE') delete params.flow_package
      //   delete params.superior_popularity_type
      // }

      return params
    },
    targetPlanChange(val) {
      const targetPlan = this.targetPlan.filter((ret) => ret.check).pop()
      this.$set(targetPlan, 'targetingName', val)
    },
    // 定向还原默认值
    targetRadioChange(key) {
      this.radioChange(key)
    },
    // 定向mixcheck还原
    targetMultChange({ key, value }) {
      this.multRadioChange(value, key)
    },
    // 人群包选定
    audienceRadioChange({ item, account, type, audience }) {
      if (audience === 'clear') {
        // 清空人群包 单账号
        const tags = this.curTarget.retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1) {
          this.$set(tags[index], 'includes', [])
          this.$set(tags[index], 'excludes', [])
        }
        if (this.$refs.targeting && this.$refs.targeting[0]) {
          this.$refs.targeting[0].resetAudience()
          this.$refs.targeting[0].currentRetarget(account)
        }
      } else if (item.select !== type) {
        const tags = this.curTarget.retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1 && type === 'include') {
          if (audience === 'append') {
            const idx = tags[index].excludes.findIndex((met) => met.id === item.id)
            if (idx > -1) tags[index].excludes.splice(idx, 1)
            tags[index].includes.push(item)
          } else {
            const idx = tags[index].includes.findIndex((met) => met.id === item)
            if (idx > -1) tags[index].includes.splice(idx, 1)
          }
        } else if (index > -1 && type === 'exclude') {
          if (audience === 'append') {
            const idx = tags[index].includes.findIndex((met) => met.id === item.id)
            if (idx > -1) tags[index].includes.splice(idx, 1)
            tags[index].excludes.push(item)
          } else {
            const idx = tags[index].excludes.findIndex((met) => met.id === item)
            if (idx > -1) tags[index].excludes.splice(idx, 1)
          }
        }
      }
    },
    mediaAudienceRadioChange({ item, account, type, audience }) {
      if (audience === 'clear') {
        // 清空媒体包 单账号
        const tags = this.curTarget.media_retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1) {
          this.$set(tags[index], 'mediaIncludes', [])
          this.$set(tags[index], 'mediaExcludes', [])
        }
        if (this.$refs.targeting && this.$refs.targeting[0]) {
          this.$refs.targeting[0].resetMediaAudience()
          this.$refs.targeting[0].currentMediaRetarget(account)
        }
      } else if (item.select !== type) {
        const tags = this.curTarget.media_retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1 && type === 'include') {
          if (audience === 'append') {
            if (tags[index].mediaExcludes.length) {
              this.$Modal.confirm({
                title: '确认更改选项',
                content: '媒体定向不支持同时定向且排除操作，更换操作类型后已选流量包会被清空，是否继续？',
                onOk: () => {
                  tags[index].mediaIncludes.push(item)
                  tags[index].mediaExcludes.splice(0, tags[index].mediaExcludes.length)
                }
              })
            } else tags[index].mediaIncludes.push(item)
          } else {
            const idx = tags[index].mediaIncludes.findIndex((met) => met.id === item)
            if (idx > -1) tags[index].mediaIncludes.splice(idx, 1)
          }
        } else if (index > -1 && type === 'exclude') {
          if (audience === 'append') {
            if (tags[index].mediaIncludes.length) {
              this.$Modal.confirm({
                title: '确认更改选项',
                content: '媒体定向不支持同时定向且排除操作，更换操作类型后已选流量包会被清空，是否继续？',
                onOk: () => {
                  tags[index].mediaExcludes.push(item)
                  tags[index].mediaIncludes.splice(0, tags[index].mediaIncludes.length)
                }
              })
            } else tags[index].mediaExcludes.push(item)
          } else {
            const idx = tags[index].mediaExcludes.findIndex((met) => met.id === item)
            if (idx > -1) tags[index].mediaExcludes.splice(idx, 1)
          }
        }
      }
    },
    audienceSelectAll({ type, check, checkList, account }) {
      const bool = Boolean(check)
      const tags = this.curTarget.retargeting_tags
      const index = tags.findIndex((ret) => ret.id === account)
      const unself = type === 'includes' ? 'excludes' : 'includes'
      if (isArray(tags) && isArray(checkList)) {
        checkList.forEach((ret) => {
          const disbool = type === 'excludes' && ret.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'
          !disbool && this.$set(ret, 'select', type.substr(0, type.length - 1))
          if (bool) {
            const idx = tags[index][unself].findIndex((met) => met.id === ret.id)
            const sdx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][unself].splice(idx, 1)
            !disbool && sdx < 0 && tags[index][type].push(ret)
          } else {
            const idx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][type].splice(idx, 1)
          }
        })
      }
    },
    mediaAudienceSelectAll({ type, check, checkList, account }) {
      const bool = Boolean(check)
      const tags = this.curTarget.media_retargeting_tags
      const index = tags.findIndex((ret) => ret.id === account)
      const unself = type === 'mediaIncludes' ? 'mediaExcludes' : 'mediaIncludes'
      if (isArray(tags) && isArray(checkList)) {
        checkList.forEach((ret) => {
          // const disbool = type === 'mediaExcludes'
          this.$set(ret, 'select', type.substr(0, type.length - 1))
          if (bool) {
            const idx = tags[index][unself].findIndex((met) => met.id === ret.id)
            const sdx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][unself].splice(idx, 1)
            sdx < 0 && tags[index][type].push(ret)
          } else {
            const idx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][type].splice(idx, 1)
          }
        })
      }
    },
    // 人群包清空
    audienceClear() {
      const tags = this.curTarget.retargeting_tags
      if (isArray(tags)) {
        tags.forEach((ret) => {
          this.$set(ret, 'includes', [])
          this.$set(ret, 'excludes', [])
        })
      }
      if (this.$refs.targeting && this.$refs.targeting[0]) this.$refs.targeting[0].resetAudience()
    },
    // 媒体包清空
    mediaAudienceClear() {
      const tags = this.curTarget.media_retargeting_tags
      if (isArray(tags)) {
        tags.forEach((ret) => {
          this.$set(ret, 'mediaIncludes', [])
          this.$set(ret, 'mediaExcludes', [])
        })
      }
      if (this.$refs.targeting && this.$refs.targeting[0]) this.$refs.targeting[0].resetMediaAudience()
    },
    // 版位全选
    selectInventoryAll(check) {
      const inventory_types = [
        'INVENTORY_FEED',
        'INVENTORY_VIDEO_FEED',
        'INVENTORY_AWEME_FEED',
        'INVENTORY_TOMATO_NOVEL',
        'INVENTORY_UNION_SLOT',
        'UNION_BOUTIQUE_GAME'
      ]
      this.curTarget.inventory_type = check ? inventory_types : []
    },
    preloadData() {
      this.$Spin.show()
      // this.show = true
      Promise.all([
        adAccount({
          mediaId: 10,
          authFlag: 1
        }),
        getCaoHuaGames()
      ]).then((data) => {
        this.$Spin.hide()
        if (isArray(data)) {
          const [accountData, gameData] = data
          this.originData = JSON.parse(JSON.stringify(accountData))
          this.accountIds = deepCopy(this.originData).map((ret) => {
            return { id: ret.id, name: ret.name, children: [] }
          })
          isArray(gameData) && (this.dataGames = gameData)
          if (this.editState) {
            this.getData()
          } else {
            // 默认增加一个定向
            // this.appendTargeter()
            // timeout(800).then(() => {
            //   this.setTargeter(0)
            // })
          }
        }
      })
    },
    getData() {
      this.$Spin.show()
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      const targetings = getSession('targetings') || []
      this.accountIds = getSession('accounts') || []
      this.subject = Number(getSession('subject')) || 2
      this.createType = getSession('createType') || 'CREATE'

      this.formItem = Object.assign({}, this.formItem, out_plan_info, plan_info)

      this.reverWeektime(this.formItem.delivery_setting.schedule_time)
      timeout(600).then(() => {
        this.targetPlan = targetings
        this.setTargeter(0)
      })
    },
    reverWeektime(schedule) {
      let idx = 0
      for (let i = 0; i < this.weektimeData.length; i++) {
        const children = this.weektimeData[i].child
        for (let j = 0; j < children.length; j++) {
          const n = schedule.substr(idx, 1)
          this.$set(this.weektimeData[i].child[j], 'check', Boolean(parseInt(n)))
          idx++
        }
      }
    },
    async submitToNext() {
      const params = this.adjustment()
      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(params)] // 表单验证
      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      // 小程序平台校验配置信息
      if (params.ch_platform_id === 3) {
        const { gameAppInfo } = await checkGameInfo({ gameId: params.game_id })
        const { wechatAppId, originId, wechatCbUrl, wechatToken } = gameAppInfo || {}

        if (!originId || !wechatAppId || !wechatCbUrl || !wechatToken) {
          this.$Message.warning(
            '该游戏未在【天工开物】-【AI工具】-【游戏应用管理】添加游戏相关配置【小程序原始ID、小程序APPID、头条小程序回调URL、头条小程序回调Token】，请联系投放负责人或运营进行配置'
          )
          throw new Error('checkGameInfo check failed')
        }
      }

      const inner_plan_params = pullKeys(
        [
          'plan_name',
          'ch_platform_id',
          'game_id',
          'landing_type',
          'package',
          'game_address',
          'callback_switch',
          'plan_auto_task_id',
          'monitorPlan',
          'media_targeting_id',
          'media_pack_switch',
          'call_type'
        ],
        params
      )

      const outKeys = [
        'landing_type',
        'app_type',
        'convert',
        'app_promotion_type',
        'delivery_mode',
        'marketing_goal',
        'ad_type',
        'micro_promotion_type',
        'download_url',
        'delivery_setting',
        'timeRange',
        'subscribe_url'
      ]

      if (params.keywordSwitch) {
        outKeys.push(...['audience_extend', 'keywords'])

        if (params.search_bid_ratio) {
          outKeys.push('search_bid_ratio')
        }
      }
      const outer_plan_params = pullKeys(outKeys, params)

      // ios 应用下载如果配置了子链接，download_url
      if (inner_plan_params.ch_platform_id === 2) {
        if (params.app_promotion_type === 'DOWNLOAD' && params.download_url) {
          outer_plan_params.download_url = params.download_url?.trim()
        }
      }

      if (inner_plan_params.ch_platform_id === 1) {
        if (params.app_promotion_type === 'RESERVE') {
          delete inner_plan_params.media_pack_switch
        }
      }

      if (inner_plan_params.ch_platform_id === 2) delete inner_plan_params.media_pack_switch
      const targetings = this.targetPlan.map((ret) => {
        // 穿山甲参数处理
        // if (!(ret.targetingParam.inventory_type.length === 1 && ret.targetingParam.inventory_type.includes('INVENTORY_UNION_SLOT'))) {
        //   delete ret.targetingParam.union_video_type
        // }
        // 人群包
        ret.targetingParam.audiences = ret.targetingParam.retargeting_tags.map((met) => {
          return {
            account_id: met.id,
            retargeting_tags_include: isArray(met.includes) ? met.includes.map((m) => m.id) : [],
            retargeting_tags_exclude: isArray(met.excludes) ? met.excludes.map((m) => m.id) : []
          }
        })
        // 穿山甲媒体包
        ret.targetingParam.mediaAudiences = ret.targetingParam.media_retargeting_tags.map((met) => {
          return {
            account_id: met.id,
            flow_package: isArray(met.mediaIncludes) ? met.mediaIncludes.map((m) => m.id) : [],
            exclude_flow_package: isArray(met.mediaExcludes) ? met.mediaExcludes.map((m) => m.id) : []
          }
        })
        return ret
      })
      // if (this.formItem.isLive) Object.assign(outer_plan_params, {inventory_catalog: 'MANUAL', inventory_type: ['INVENTORY_AWEME_FEED']})
      // 穿山甲参数验证
      // if (outer_plan_params.delivery_range === 'DEFAULT' && outer_plan_params.union_video_type) delete outer_plan_params.union_video_type

      // 广告名称报错
      if (this.dynErr) {
        this.$Message.error('广告名称错误：' + this.dynErr)
        return
      }

      // 保存并修改
      setSession('inner_plan_params', inner_plan_params)
      setSession('outer_plan_params', outer_plan_params)
      setSession('targetings', targetings)
      setSession('accounts', this.accountIds)
      setSession('subject', this.subject)
      setSession('createType', this.createType)

      // 事件管理跳转
      this.showGoalModal = true
    },
    jump() {
      if (this.editState) this.$router.push({ name: 'localadt', query: { t: 'edit' } })
      else this.$router.push({ name: 'localadt' })
    },
    valid() {
      const rules = [
        {
          name: 'multAccount',
          require: true,
          min: 1,
          desc: '账号'
        },
        {
          name: 'formItem/plan_name',
          require: true,
          min: 3,
          max: 90,
          desc: '项目名称'
        },
        {
          name: 'formItem/game_id',
          require: true,
          min: 1,
          desc: '投放应用'
        },
        {
          name: 'formItem/package',
          require: true,
          min: 4,
          max: 100,
          desc: '应用包名'
        }
        // {
        //   name: 'formItem/toutiaoAcid',
        //   require: true,
        //   relyon: 'formItem/ch_platform_id',
        //   relyvalue: 1,
        //   desc: '头条分包'
        // }
      ]
      return this.invalid(rules)
    },
    customValid(params) {
      const { budget } = params.delivery_setting
      const { start_time, end_time } = params.delivery_setting
      const day = betweenTime(start_time, end_time) // 投放天数
      const lowBudget = 300 // 最低预算
      const totalBudget = day * lowBudget // 最低总预算
      let plan_name_length = getByteLen(params.plan_name)
      const err = []
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = params.plan_name.match(regexp)

      if (isArray(values)) {
        values.forEach((ret) => {
          ret === '{项目组名}' && (plan_name_length += 11)
          ret === '{计划组名}' && (plan_name_length += 11)
        })
      }

      if (params.app_promotion_type === 'RESERVE') {
        if (!params.subscribe_url.trim()) {
          err.push({ feild: '预约链接', msg: '请填写预约链接' })
        }
      }
      // 安卓应用下载头条分包校验
      if (params.ch_platform_id === 1) {
        if (params.app_promotion_type === 'DOWNLOAD') {
          if (!params.toutiaoAcid) {
            err.push({ feild: '头条分包', msg: '头条分包不能为空' })
          }
        }
      }

      if (params.ch_platform_id === 2 && params.app_promotion_type === 'DOWNLOAD') {
        if (!params.download_url?.trim()) {
          err.push({ feild: '应用链接', msg: '请填写应用链接' })
        }
      }

      // 搜索快投
      // 搜索快投
      const { search_bid_ratio, delivery_mode, keywordSwitch } = params
      if (delivery_mode === 'MANUAL' && keywordSwitch) {
        if (search_bid_ratio) {
          const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
          if (Number(search_bid_ratio) >= 1 && Number(search_bid_ratio) <= 2) {
            if (!twoDigit.test(search_bid_ratio)) {
              err.push({ feild: '搜索快投', msg: '出价系数值小数点后最多两位' })
            }
          } else {
            err.push({ feild: '搜索快投', msg: '出价系数取值范围1.00 ~ 2.00' })
          }
        }
      }

      if (plan_name_length > 90) err.push({ feild: '广告名称', msg: `加入动态词后的长度${plan_name_length}，超过了90个字符` })

      // if (params.package) err.push({feild: '广告名称', msg: `加入动态词后的长度${plan_name_length}，超过了90个字符`})

      // 预算设置

      if (params.delivery_setting.budget_mode === 'BUDGET_MODE_DAY' && budget < lowBudget) {
        err.push({ feild: '日预算', msg: `应大于${lowBudget}元` })
      } else if (params.delivery_setting.budget_mode === 'BUDGET_MODE_TOTAL' && budget < totalBudget) {
        err.push({ feild: '总预算', msg: `应大于${totalBudget}元` })
      }

      // 自动投放且竞价策略为稳定成本，校验目标出价和深度出价或roi系数
      if (this.isProcedural && ['CUSTOM'].includes(params.delivery_setting.bid_type)) {
        let { cpa_bid, deep_bid_type, roi_goal, deep_cpabid, budget } = params.delivery_setting
        cpa_bid = Number(cpa_bid)
        deep_cpabid = Number(deep_cpabid)
        roi_goal = Number(roi_goal)

        if (!cpa_bid || cpa_bid < 0.1 || cpa_bid > 10000) {
          err.push({ feild: '目标出价', msg: '应大于0.1元小于10000元' })
        }

        if (cpa_bid > budget) {
          err.push({ feild: '目标出价', msg: '应小于日预算' })
        }

        if (deep_bid_type === 'DEEP_BID_MIN') {
          if (!deep_cpabid || deep_cpabid < 0.1 || deep_cpabid > 10000) {
            err.push({ feild: '深度出价', msg: '应大于0.1元小于10000元' })
          }
        }
        if (['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(deep_bid_type)) {
          if (!roi_goal || roi_goal < 0.0001 || roi_goal > 5) {
            err.push({ feild: 'ROI系数', msg: '应大于0.0001元小于5' })
          }
        }

        // 自动投放人群包只能选排除
        const retargetingTagsInclude = this.targetPlan.some((ret) => {
          const [retargeting_tags] = ret.targetingParam.retargeting_tags || []
          return retargeting_tags?.includes?.length
        })

        if (retargetingTagsInclude) {
          err.push({ feild: '定向人群包', msg: '自动投放模式只能选择排除人群' })
        }
      }

      // 定向名称过长
      const moreTargetName = this.targetPlan.some((ret) => {
        return isEmpty(ret.targetingName) || getByteLen(ret.targetingName) > 20
      })
      moreTargetName && err.push({ feild: '定向包名称', msg: '不符合规则1-20个字符，请逐个定向检查' })

      // 手机价格不能相同
      const targetSame = this.targetPlan.some((ret) => {
        return isArray(ret.targetingParam.launch_price) && ret.targetingParam.launch_price[0] === ret.targetingParam.launch_price[1]
      })
      targetSame && err.push({ feild: '手机价格', msg: '价格区间不能相等，请逐个定向检查' })

      // 定向版位必选
      const targetInventory = this.targetPlan.some((ret) => {
        return isArray(ret.targetingParam.inventory_type) && ret.targetingParam.inventory_type.length === 0
      })
      targetInventory && err.push({ feild: '投放位置', msg: '定向版位不能为空，请逐个定向检查' })

      return err
    }
  },
  data() {
    return {
      showSearchBidKeywordModal: false, // 搜索快投关键词弹窗
      show: null,
      asyning: null, // 异步加载
      subject: 2,
      createType: 'CREATE',
      accountIds: [],
      originData: [], // 原始数据用于还原

      searchBidKeywordList: [], // 搜索快投关键词

      check: null, // 计划名检查
      dynErr: '',
      dynpos: [], // 动态词位置
      dynwords: [], // 动态词
      selectorShow: null, // 导入定向
      formItem: {
        // 基础信息
        plan_name: '', // 项目名称
        ch_platform_id: 1, // 平台类型
        game: {},
        game_id: '', // 草花投放游戏ID
        package: '', // 广告应用下载包名
        monitorPlan: [], // 自动化任务
        callback_switch: 1, // 回调开关
        landing_type: 'APP', // 推广目的
        app_promotion_type: 'DOWNLOAD', // 子目的
        promotion_content: 'WECHAT', // 投放内容
        delivery_mode: 'MANUAL', // 投放模式
        marketing_goal: 'VIDEO_AND_IMAGE', // 营销场景
        ad_type: 'ALL', // 所有广告
        micro_promotion_type: 'WECHAT_GAME', // 小程序投放内容
        media_pack_switch: 1, // 头条分包
        game_address: '', // 游戏下载地址
        subscribe_url: '', // 预约地址
        call_type: '1', // 上报媒体方式
        download_url: '', // 广告应用下载链接
        app_type: 'APP_ANDROID', // 广告应用下载类型
        // 排期与预算
        delivery_setting: {
          schedule_type: 'SCHEDULE_FROM_NOW',
          schedule_time: '',
          start_time: formatDate(new Date(), 'yyyy-MM-dd'),
          end_time: formatDate(new Date(), 'yyyy-MM-dd'),
          bid_type: 'CUSTOM', // 竞价策略
          bid_type_upgrade: 'CUSTOM', // 广告潜力探索
          bid_speed: 'FAST', // 投放速度
          budget_mode: 'BUDGET_MODE_INFINITE', // 项目预算
          budget_optimize_switch: 'OFF', // 项目预算择优分配
          budget: '', // 日预算
          deep_cpabid: '', // 深度出价
          roi_goal: '', // 深度roi
          deep_bid_type: '' // 深度优化方式
        },
        timeRange: 'NONE', // 投放时间段 默认不传此参数

        // 搜索快投
        keywordSwitch: 0,
        search_bid_ratio: '',
        audience_extend: 'ON',
        keywords: []
      },

      // 基础信息相关数据
      dataGames: [], // 应用下拉数据源
      datetime: [],
      weektimeData: [],
      disableTotal: null, // 是否采用总预算
      disabledDate: disabledDate,
      datetimeOption: { shortcuts, disabledDate }, // 快速选择配置
      targetPlan: [], // 定向管理

      // 用户定向
      cityData: cityData,
      tagsData: tagsData,
      gategoryData: gategoryData,
      brandData: brandData,
      brandDataAll: brandDataAll,
      articleData: articleData,
      autotendData: autotendData,
      androidVersion: androidVersion,
      iOSVersion: iOSVersion,
      flowPackage: [],

      showGoalModal: false, // 事件管理弹窗
      saveTargetingId: '', // 定向包ID
      saveTitle: '',
      saveDesc: ''
    }
  },
  watch: {
    // 投放时间段 今日头条提交参数处理
    weektimeData: {
      handler(nVal) {
        this.formItem.delivery_setting.schedule_time = getWeektime(nVal)
      },
      deep: true
    },
    multAccount: {
      handler(nVal, oVal) {
        if (nVal.length !== oVal.length) {
          const id = this.getExtraArrEl(nVal, oVal).id
          const el = this.accountIds.filter((ret) => ret.id === id).pop()

          if (oVal.length === 0) {
            // 从无到有
            this.appendTargeter()
            timeout(800).then(() => {
              this.setTargeter(0)
            })
          } else if (nVal.length === 0) {
            // 账号清空
            this.targetPlan = []
          } else if (nVal.length > oVal.length) {
            // 账号添加
            this.targetPlan.forEach((ret) => {
              ret.targetingParam.retargeting_tags.push(localAudience([el]).pop())
              ret.targetingParam.media_retargeting_tags.push(localMediaAudience([el]).pop())
            })
          } else if (nVal.length < oVal.length) {
            // 账号减少
            this.targetPlan.forEach((ret) => {
              ret.targetingParam.retargeting_tags = ret.targetingParam.retargeting_tags.filter((t) => t.id !== el.id)
              ret.targetingParam.media_retargeting_tags = ret.targetingParam.media_retargeting_tags.filter((t) => t.id !== el.id)
            })
            if (this.curTarget.retargeting_type === 'RETARGETING_INCLUDE') {
              this.$refs.targeting[0].currentRetarget(this.multAccount[0].id)
            }
            if (this.curTarget.superior_popularity_type === 'CUSTOM') {
              this.$refs.targeting[0].currentMediaRetarget(this.multAccount[0].id)
            }
          }
        }
      }
    },
    'formItem.monitorPlan'(nVal) {
      if (isArray(nVal) && nVal.length) {
        this.formItem.plan_auto_task_id = nVal.map((ret) => ret.id).join(',')
      } else {
        this.formItem.plan_auto_task_id = undefined
      }
    }
  },
  created() {
    this.weektimeData = weektimeData
    this.$store.commit('Toutiaonewlocal/clearModulerLinks')
    this.dynwords = dynwords
    this.preloadData()
    // 在session中写入时间戳，getLocalforage 用来标记在indexedDB中的数据
    const plan_timestamp = getSession('plan_timestamp')
    if (!plan_timestamp) {
      setSession('plan_timestamp', Date.now())
    }
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  ::v-deep .row-item {
    align-items: flex-start;

    span.item-field {
      height: 32px;
      line-height: 32px;
    }

    .col-pull-right {
      text-align: right;
    }
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .m-dynamic {
    padding-top: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-left: 12px;
    }
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  .m-toutiao-ad {
    line-height: 22px;
  }
}

.split-line {
  margin: 0 10px;
  color: #dcdee2;
}
</style>
